import React from 'react';
import {MultipleCheckboxFilterProps, OptionProps} from './types';
import {Checkbox, FormControlLabel} from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import {OptionFilter, optionStyles} from './OptionFilter';
import {tid} from '../../../testUtils';
import xor from 'lodash/xor';

const CheckboxOption: React.FC<OptionProps<any>> = <T,>(props: OptionProps<T>) => {
  const {
    option,
    optionLabel,
    optionValue,
    optionValueMatcher,
    handler,
    getDataTestIdPostfixFromValue = (value: any) => value,
  } = props;
  const {value, onChange, type, ...otherHandlerProps} = handler();
  const newValue = optionValue(option);
  const selected = optionValueMatcher ? value.some((x: T) => optionValueMatcher(option, x)) : value.includes(newValue);
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...otherHandlerProps}
          value={true}
          checked={selected}
          onChange={() =>
            onChange(
              selected
                ? value.filter((existingValue: T) =>
                    optionValueMatcher ? !optionValueMatcher(existingValue, newValue) : existingValue !== newValue,
                  )
                : [...value, newValue],
            )
          }
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          classes={{root: optionStyles.checkboxRoot}}
          inputProps={tid('multiple-checkbox-option-checkbox', getDataTestIdPostfixFromValue(newValue)) as object}
        />
      }
      label={<span>{optionLabel(option)}</span>}
      classes={{root: optionStyles.label, label: optionStyles.optionLabel}}
      {...tid('multiple-checkbox-option-label', getDataTestIdPostfixFromValue(newValue))}
    />
  );
};

export const MultipleCheckboxFilter: React.FC<MultipleCheckboxFilterProps<any>> = <T,>(
  props: MultipleCheckboxFilterProps<T>,
) => (
  <OptionFilter
    {...props}
    optionComponent={CheckboxOption}
    // @ts-expect-error: adjusting the type error
    isEmpty={(value) => value.length === props.control.formState.length && !xor(props.control.formState, value).length}
    // @ts-expect-error: adjusting the type error
    buildEmptyValue={() => props.control.formState}
    {...tid('multiple-checkbox-filter', props.label)}
  />
);
